import React, { Component } from "react";
import Month from "shared/CalendarView/Month.shared";
import { shouldComponentUpdate } from "react-window";

export default class Row extends Component {
  shouldComponentUpdate = shouldComponentUpdate.bind(this);

  render() {
    const { index, style, data } = this.props;
    const {
      months,
      dateHelper,
      calnoteObj,
      selectedDate,
      setSelectedDate,
      activeDate,
      setActiveDate,
      itemType,
    } = data;
    return (
      <Month
        style={style}
        itemType={itemType}
        monthData={months[index]}
        dateHelper={dateHelper}
        calnoteObj={calnoteObj}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        activeDate={activeDate}
        setActiveDate={setActiveDate}
        isCurrentMonth={index === 0}
      />
    );
  }
}
